import { render } from "./EditProjectUsersPage.vue?vue&type=template&id=a48ee386"
import script from "./EditProjectUsersPage.vue?vue&type=script&lang=js"
export * from "./EditProjectUsersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__